'use client'

import { createLazyPostHog } from '@repo/observability/lazy'

/**
 * Lazy facade over posthog-js — the app's largest script, kept out of the hydration-gating chunks.
 * Init happens at idle (`instrumentation-client.ts`). Consumers must reach PostHog exclusively
 * through {@link withPostHog}: a static posthog-js import anywhere pulls the bundle back into the
 * initial graph.
 *
 * `posthog-js/dist/module.full.no-external` is the same SDK with the recorder/surveys/autocapture
 * extensions inlined, so PostHog never injects a `<script>` from `eu-assets.i.posthog.com` at
 * runtime — every byte stays under our build pipeline, i.e. `'self'` for CSP.
 */
export const { withPostHog, lazyInitPostHog } = createLazyPostHog({
  load: () => import('posthog-js/dist/module.full.no-external').then(mod => mod.default),
  enabled:
    typeof window !== 'undefined' &&
    Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY) &&
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
})
